/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      marginBottom: 50,
      marginTop: 64,
    },
    box: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      border: "1px solid",
      borderColor: "grey",
      borderRadius: "10px",
      width: "500px",
      height: "400px",
      padding: "24px",
      margin: "32px 0",
    },
    textFieldResetPassword: {
      position: "relative",
      marginBottom: 18,
    },
    buttonBase: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginTop: 12,
    },
    authButton: {
      textTransform: "capitalize",
      width: "100%",
    },
    loginButton: {
      textTransform: "capitalize",
      display: "flex",
      flex: "1 1 50%",
    },
    link: {
      color: "#fff",
      border: "none",
      display: "flex",
      flex: "1 1 50%",
      marginLeft: theme.spacing(2),
      "&:hover": {
        border: "none",
      },
    },
    inputLabel: {
      color: theme.palette.primary.main,
    },
    footer: {
      display: "flex",
    },
    footerButton: {
      textTransform: "capitalize",
      textDecoration: "underline",
      "&:hover": {
        textDecoration: "underline",
        color: theme.palette.primary.main,
        background: "none",
      },
    },
    modalBox: {
      position: "relative",
      margin: "auto",
      top: "35%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-evenly",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid",
      borderColor: "grey",
      borderRadius: "10px",
      width: "500px",
      height: "250px",
      padding: "24px",
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
    },
    inputRoot: {
      "-webkit-box-shadow": "0 0 0px 1000px #f6f8f7 inset",
    },
    form: {
      backgroundColor: "#f6f8f7",
      width: "100%",
    },
    resetFormHeader: {
      width: "100%",
      fontWeight: "bold",
      marginBottom: 8,
    },
    resetFormConent: {
      fontSize: "16px",
      width: "100%",
    },
    resetFormActions: {
      width: "100%",
      "& button": {
        marginTop: 8,
        textTransform: "capitalize",
      },
    },
    helperText: {
      position: "absolute",
      bottom: "-22px",
      color: "#f44336",
    },
    textField: {
      position: "relative",
    },
    errorTypo: {
      color: "#f44336",
    },
  });
